const eventTypes = {
  log_in: 'log_in',
  forgot_password: 'forgot_password',
  log_out: 'log_out',
  search_equipment: 'search_equipment',
  dash_apply_filter: 'dash_apply_filter',
  eq_view: 'eq_view',
  eq_toggle_status: 'eq_toggle_status',
  eq_request_data: 'eq_request_data',
  eq_sensor_history: 'eq_sensor_history',
  eq_sensor_history_timeframe: 'eq_sensor_history_timeframe',
  eq_alert_details: 'eq_alert_details',
  eq_alert_clear: 'eq_alert_clear',
  eq_alert_history: 'eq_alert_history',
  eq_service_view: 'eq_service_view',
  eq_service_add: 'eq_service_add',
  eq_service_update: 'eq_service_update',
  eq_motorhead_toggle: 'eq_motorhead_toggle',
  eq_replace_controller: 'eq_replace_controller',
  eq_cycle_towers: 'eq_cycle_towers',
  eq_cycle_autowash: 'eq_cycle_autowash',
  eq_debug: 'eq_debug',
  eq_vis_toggle: 'eq_vis_toggle',
  eq_update: 'eq_update',
  sched_update_toggle: 'sched_update_toggle',
  sched_add: 'sched_add',
  sched_update: 'sched_update',
  sched_delete: 'sched_delete',
  user_add: 'user_add',
  user_update: 'user_update',
  user_delete: 'user_delete',
  group_add: 'group_add',
  group_update: 'group_update',
  group_delete: 'group_delete',
  tandem_add: 'tandem_add',
  tandem_update: 'tandem_update',
  tandem_delete: 'tandem_delete',
  org_add: 'org_add',
  org_update: 'org_update',
  org_delete: 'org_delete',
  location_add: 'location_add',
  location_update: 'location_update',
  location_delete: 'location_delete',
  eq_transfer: 'eq_transfer',
  user_notifications: 'user_notifications',
};

export const ActiveEvents = [
  eventTypes.log_in, 
  eventTypes.log_out, 
  eventTypes.search_equipment, 
  eventTypes.eq_view,
  eventTypes.eq_request_data,
  eventTypes.eq_sensor_history,
  eventTypes.eq_alert_details,
  eventTypes.eq_update,
  eventTypes.user_notifications,
]

export default eventTypes;